import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=28e13b98"
import script from "./debug.ts?vue&type=script&lang=js&external"
export * from "./debug.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports